window.__bhWishlistToastI18n = {
  'Added to Wishlist': "위시리스트에 담았습니다",
  'Removed from Wishlist': "위시리스트에서 제거했습니다"
};
/**
 * BH Simple Wishlist: toastFunction / DOM 토스트 영문 치환. 위 객체는 로케일(`| t`) 기준.
 */
(function () {
  var DEFAULT_MAP = {
    'Added to Wishlist': 'Added to Wishlist',
    'Removed from Wishlist': 'Removed from Wishlist',
  };

  function getMap() {
    var w = typeof window !== 'undefined' ? window.__bhWishlistToastI18n : null;
    if (w && typeof w === 'object') {
      return w;
    }
    return DEFAULT_MAP;
  }

  function translateMessage(msg) {
    if (typeof msg !== 'string') return msg;
    var map = getMap();
    return map[msg] !== undefined ? map[msg] : msg;
  }

  function wrapToastFunction(orig) {
    if (!orig || orig.__bhToastWrapped) return orig;
    function wrapped() {
      var args = Array.prototype.slice.call(arguments);
      if (args.length >= 2) args[1] = translateMessage(args[1]);
      return orig.apply(this, args);
    }
    wrapped.__bhToastWrapped = true;
    wrapped.__bhOriginal = orig;
    return wrapped;
  }

  function tryPatchToastFunction() {
    var t = window.toastFunction;
    if (typeof t !== 'function') return false;
    if (t.__bhToastWrapped) return true;
    window.toastFunction = wrapToastFunction(t);
    return true;
  }

  var RETRY_MS = [0, 50, 100, 200, 500, 1000, 2000, 3000, 5000];
  RETRY_MS.forEach(function (ms) {
    setTimeout(tryPatchToastFunction, ms);
  });

  var pollCount = 0;
  var pollId = setInterval(function () {
    pollCount += 1;
    tryPatchToastFunction();
    if (pollCount >= 20) clearInterval(pollId);
  }, 500);

  function replaceEnglishInTextNode(node) {
    if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
    var v = node.nodeValue;
    var changed = false;
    var map = getMap();
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i += 1) {
      var en = keys[i];
      if (v.indexOf(en) !== -1) {
        v = v.split(en).join(map[en]);
        changed = true;
      }
    }
    if (changed) node.nodeValue = v;
  }

  function walk(node) {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      replaceEnglishInTextNode(node);
      return;
    }
    var children = node.childNodes;
    for (var i = 0; i < children.length; i += 1) {
      walk(children[i]);
    }
  }

  function startDomObserver() {
    var root = document.body;
    if (!root) return;

    walk(root);

    var mo = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m += 1) {
        var mut = mutations[m];
        if (mut.type === 'childList' && mut.addedNodes && mut.addedNodes.length) {
          for (var i = 0; i < mut.addedNodes.length; i += 1) {
            walk(mut.addedNodes[i]);
          }
        } else if (mut.type === 'characterData' && mut.target) {
          replaceEnglishInTextNode(mut.target);
        }
      }
    });

    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.body) {
    startDomObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startDomObserver);
  }
})();
